import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const functions = getFunctions();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const getUsersFunction = httpsCallable(functions, 'fetchUsers');
      const result = await getUsersFunction();
      setUsers(result.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const makeAdmin = async (uid) => {
    try {
      const setAdminFunction = httpsCallable(functions, 'setAdminRole');
      const result = await setAdminFunction({ uid });
      alert(result.data.message);
      await fetchUsers(); // Refresh the user list
      
      // Force token refresh for current user
      const auth = getAuth();
      if (auth.currentUser) {
        await auth.currentUser.getIdToken(true);
      }
    } catch (error) {
      console.error('Error making user admin:', error);
      alert(`Failed to make user an admin: ${error.message}`);
    }
  };

  const makeWorker = async (uid) => {
    try {
      const setWorkerFunction = httpsCallable(functions, 'setWorkerRole');
      const result = await setWorkerFunction({ uid });
      alert(result.data.message);
      await fetchUsers(); // Refresh the user list
      
      // Force token refresh for current user
      const auth = getAuth();
      if (auth.currentUser) {
        await auth.currentUser.getIdToken(true);
      }
    } catch (error) {
      console.error('Error making user worker:', error);
      alert(`Failed to make user a worker: ${error.message}`);
    }
  };

  const getUserRole = (customClaims) => {
    if (customClaims?.admin) return 'Admin';
    if (customClaims?.worker) return 'Worker';
    return 'User';
  };

  if (loading) return <div className="text-center py-4">Loading users...</div>;
  if (error) return <div className="text-red-500 text-center py-4">Error: {error}</div>;

  return (
    <div className="container mx-auto px-4">
      <h2 className="text-2xl font-bold mb-4">User Management</h2>
      {users.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 border-b text-left">Email</th>
                <th className="py-2 px-4 border-b text-left">Role</th>
                <th className="py-2 px-4 border-b text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.uid} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{user.email}</td>
                  <td className="py-2 px-4 border-b">{getUserRole(user.customClaims)}</td>
                  <td className="py-2 px-4 border-b">
                    <button 
                      onClick={() => makeWorker(user.uid)}
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded mr-2"
                    >
                      Make Worker
                    </button>
                    <button 
                      onClick={() => makeAdmin(user.uid)}
                      className="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded"
                    >
                      Make Admin
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-center py-4">No users found.</p>
      )}
      <button 
        onClick={fetchUsers} 
        className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Refresh Users
      </button>
    </div>
  );
};

export default UserManagement;